module.exports = __webpack_public_path__ + "img/img_5.22520465.png";